export default __webpack_public_path__ + "static/logo-150f681cd2dc56b52d96325a1fc43ce3.png";